import React from 'react';
import { connect } from 'react-redux';
import { crafterConf } from '@craftercms/classes';
import history from './history';

import Header from './components/Header/Header';
import HeaderNews from './components/HeaderNews/HeaderNews';
import Footer from './components/Footer/Footer';
import BackDrop from './components/Backdrop/Backdrop';
import CookieLawBar from './components/CookieLawBar/CookieLawBar';
import { setCookie } from './utils';

import Router from './Router';
import AppHolder from './AppStyles';

const siteName = document.getElementById('studioSiteName').innerHTML || process.env.REACT_APP_SITE;

crafterConf.configure({
    site: siteName,
    baseUrl: process.env.REACT_APP_HOST
});

const App = (props) => {
    if(document.cookie.indexOf('lan=')=== -1) { 
        setCookie("lan", "en");
    }

    return (
        <AppHolder>
            <a className="skip-main" href="#main-content">Skip to main content</a>
            <a className="skip-main" href="#footer">Skip to footer</a>
            <div className="main-app" itemScope itemType="https://schema.org/WebPage">
                <Header/>
                <HeaderNews/>
                <div className="main-content" id="main-content" itemProp='mainContentOfPage'>
                    <Router history={history}/>
                    <Footer/>
                </div>
                <BackDrop active={props.backdrop} />
            </div>   
            {!props.cookieLaw && <CookieLawBar />}
        </AppHolder>
    );
}

const mapStateToProps = (store) => ({
    backdrop: store.backdrop.active,
    cookieLaw: store.cookieLaw.cookieLaw,
});

const mapDispatchToProps = (dispatch) => ({
    setDescriptor : (component) => dispatch({ type: 'SET', component: component })
})

export default connect(mapStateToProps, mapDispatchToProps)(App);
